import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-forgot-password-dialog',
    templateUrl: './forgot-password-dialog.component.html',
    styleUrls: ['./forgot-password-dialog.component.scss']
})
export class ForgotPasswordDialogComponent {
    emailControl = new FormControl('', [Validators.required, Validators.email]);
    loading = false;

    constructor(
        private authService: AuthService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>
    ) { }

    sendResetLink(): void {
        if (this.emailControl.invalid) return;

        this.loading = true;
        const email = this.emailControl.value || '';

        this.authService.requestPasswordReset(email).subscribe({
            next: () => {
                this.loading = false;
                this.snackBar.open('Reset link sent! Check your email.', 'Close', { duration: 5000 });
                this.dialogRef.close();
            },
            error: (err) => {
                this.loading = false;
                console.error(err);
                this.snackBar.open('Failed to send request.', 'Close', { duration: 3000 });
            }
        });
    }
}